import {observer} from 'mobx-react-lite'
import React from 'react'
import {useScriptsApiNavStore} from './../scripts-api-nav-store'

export const ToolsApi = observer(() => {
  const [apiNavState, apiNavStore] = useScriptsApiNavStore()

  return (
    <div className="scr-api-nav">
      {apiNavState.objects.map(item => (
        <div
          key={item.name}
          className={`scr-api-nav-item ${
            apiNavState.expandedName === item.name ? 'expanded' : ''
          } ${item.isVar ? 'variable' : ''}`}
        >
          <div
            className="scr-api-nav-item-cnt"
            onClick={() => apiNavStore.toggleHint(item)}
          >
            {apiNavState.expandedName !== item.name && (
              <i
                className="scr-api-nav-expand fa fa-plus"
                onClick={() => apiNavStore.toggle(item.name)}
              />
            )}
            {apiNavState.expandedName === item.name && (
              <i
                className="scr-api-nav-collapse fa fa-minus"
                onClick={() => apiNavStore.toggle(item.name)}
              />
            )}
            <span
              className="scr-api-nav-class-name"
              onClick={() => apiNavStore.toggle(item.name)}
              draggable="true"
              onDragStart={event => apiNavStore.dragStart(item, event)}
            >
              {item.display}
            </span>
          </div>

          {item.fields.length > 0 && apiNavState.expandedName === item.name && (
            <>
              {item.fields.map(field => (
                <div
                  key={field.display}
                  className="scr-api-nav-item scr-api-nav-field"
                  onClick={() => apiNavStore.toggleHint(field)}
                >
                  <div
                    className="scr-api-nav-item-cnt"
                    onClick={() => apiNavStore.toggleHint(field)}
                  >
                    <span
                      draggable
                      onDragStart={event => apiNavStore.dragStart(field, event)}
                      className={`not-imp: ${!field
                        .describe()
                        .startsWith('Not implemented')}`}
                    >
                      <span>
                        {field.display.split('(').shift() +
                          (field.display.includes('(') ? '(' : '')}
                      </span>
                      {field.display.includes('(') &&
                        field.display
                          .split('(')
                          .pop()
                          .split(')')
                          .shift()
                          .split(', ')
                          .map((arg, index, array) => (
                            <React.Fragment key={arg}>
                              <span className="scr-api-nav-args">{arg}</span>
                              {index !== array.length - 1 && <span>,</span>}
                            </React.Fragment>
                          ))}
                      {field.display.includes('(') && ')'}
                    </span>
                  </div>
                </div>
              ))}
            </>
          )}
        </div>
      ))}
    </div>
  )
})
